import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// Response type
export interface MessageSuggestionResponse {
  question: string;
}

// Axios GET request
export function getMessageSuggestion(
  session_uid: string,
): Promise<AxiosResponse<MessageSuggestionResponse>> {
  return axios.get<MessageSuggestionResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/sessions/${session_uid}/message-suggestion`,
  );
}
